module.exports = __webpack_public_path__ + "static/media/trashDelete.60cf5597.svg";